import {
  UserProfileSearchResultView,
  UserContactInformationView,
} from "~/backendApis/viewModel"

interface Request {
  title: string
  content: string
  buttonText: string
  formPagePath: string
}

interface RequestWithCondition {
  condition: (
    p: UserProfileSearchResultView,
    c: UserContactInformationView
  ) => boolean
  request: Request
}

/**
 * 訴求内容とその表示条件。
 * 上にある（配列のインデックスの番号が小さい）ほど優先順位が高い。
 */
const requestWithConditionList: RequestWithCondition[] = [
  {
    // 職種
    condition: (
      p: UserProfileSearchResultView,
      _c: UserContactInformationView
    ) => !p.mainLargeJobCategoryId,
    request: {
      title: "職種の設定をお願いいたします。",
      content:
        "職種を設定していただくことで、プロジェクトへの応募が可能となります。",
      buttonText: "職種を登録",
      formPagePath: "/profiles/edit/job",
    },
  },
  {
    // 稼働時間
    condition: (
      p: UserProfileSearchResultView,
      _c: UserContactInformationView
    ) => !p.availableUptimeId,
    request: {
      title: "稼働時間の設定をお願いいたします。",
      content:
        "稼働時間を設定していただくことで、プロジェクトへの応募が可能となります。",
      buttonText: "稼働時間を登録",
      formPagePath: "/profiles/edit/work_style",
    },
  },
  {
    // キャリアの概要・略歴
    condition: (
      p: UserProfileSearchResultView,
      _c: UserContactInformationView
    ) => !p.selfIntroduction,
    request: {
      title: "キャリアの概要・略歴の入力をお願いいたします。",
      content:
        "キャリアの概要・略歴を入力していただくことで、プロジェクトへの応募が可能となります。",
      buttonText: "キャリアの概要・略歴を登録",
      formPagePath: "/profiles/edit/self_introduction",
    },
  },
  {
    // 経歴・実績
    condition: (
      p: UserProfileSearchResultView,
      _c: UserContactInformationView
    ) => p.career.length === 0,
    request: {
      title: "経歴の入力をお願いいたします。",
      content:
        "経歴を入力していただくことで、プロジェクトへの応募が可能となります。",
      buttonText: "経歴を追加",
      formPagePath: "/profiles/edit/career",
    },
  },
  {
    // スキルタグ
    // MEMO イラスト付きのコンポーネントを使っているため、現状はbuttonTextしか使っていない
    condition: (
      p: UserProfileSearchResultView,
      _c: UserContactInformationView
    ) => p.skillTagList.length === 0,
    request: {
      title: "",
      content: "",
      buttonText: "スキルタグを追加",
      formPagePath: "/profiles/edit/skill_tag",
    },
  },
  {
    // 課題解決できること
    condition: (
      p: UserProfileSearchResultView,
      _c: UserContactInformationView
    ) => p.capabilities.length === 0,
    request: {
      title:
        "課題解決できることをご登録いただくことで、スカウトを受け取れる確率が上がります！",
      content:
        "企業にスカウトされている方は、課題解決できることを登録しています。",
      buttonText: "課題解決を追加",
      formPagePath: "/profiles/edit/capability",
    },
  },
]

/**
 * ユーザープロフィールの入力訴求に関するロジックを扱う関数
 */
export const userProfileInputRequestLogics = () => ({
  getRequest: (
    userProfile: UserProfileSearchResultView,
    userContactInformation: UserContactInformationView
  ): Request | null =>
    requestWithConditionList.find((elm) =>
      elm.condition(userProfile, userContactInformation)
    )?.request || null,
})
